/* @flow */

import * as React from 'react';
import { Link } from 'react-router-dom';
import { inject } from 'mobx-react';

import AuthenticationStore from 'stores/AuthenticationStore';

import ElectrorentLogoSVG from './ElectrorentLogoSVG';
import MicroleaseLogoSVG from './MicroleaseLogoSVG';

import styles from './ElectrorentLogo.module.scss';

@inject('authenticationStore')
class ElectrorentLogo extends React.Component<*> {
  render(): React.Node {
    const authenticationStore: AuthenticationStore = this.props.authenticationStore;
    const isLoggedOut: string = authenticationStore.isUserLoggedIn() ? '' : styles['logged-out'];

    return (
      <div className={`${styles['logo-container']} ${isLoggedOut}`}>
        {process.env.REACT_APP_PORTAL_NAME.toLowerCase() === 'myer' ? (
          <Link to="/dashboard">
            <ElectrorentLogoSVG />
          </Link>
        ) : (
          <Link to="/dashboard">
            <MicroleaseLogoSVG />
          </Link>
        )}
      </div>
    );
  }
}

export default ElectrorentLogo;
